// Components
import { Button } from "components"

// Utils
import { useGeneratePo } from "../utils"
import { PERMISION } from "security"

export function PoButton(params: {
  product_id: number
  qty_order: number
}): JSX.Element {
  // Hooks
  const { fetchPo, isLoading } = useGeneratePo(params.product_id, params.qty_order)

  return (
    <Button
      permission={PERMISION.INVENTORY.REGISTER.REQUIEST_FROM.UPDATE}
      className="w-full"
      color="primary"
      onClick={fetchPo}
      loading={isLoading ? "true" : undefined}
    >
      PO
    </Button>
  )
}